import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Serie } from './serie.model';

@Injectable()
export class SerieFormService {
  constructor(private fb: FormBuilder) {}

  getForm(serie: Serie = new Serie()): FormGroup {
    return this.fb.group({
      _id: [serie._id],
      name: [serie.name, Validators.required],
      slug: [serie.slug, Validators.required],
      image: [serie.image],
      banner: [serie.banner],
      description: [serie.description],
      active: [serie.active]
    });   
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/series/shared/serie-form.service.ts